<script>

import _ from 'lodash'
import { validNum } from '@/utils/validate'
import { messageTipModal } from '../../modal'
import DropTimes from './dropTimes.vue'
import dayjs from 'dayjs'
import { 
    PLAT_PLANNED_BUDGET_TYPE, LIMIT_TYPE, PLAT_TYPE, GROUP_TYPE,  
    ACTION_TYPE, ACT_MATRIX, ACTION_TYPE_DATA  ,ACTION_TYPE_LIST,
    ADJUST_TYPE, ADJUST_TYPE_LIST, ADJUST_VALUE_TYPE, ADJUST_VALUE_TYPE_LIST,
} from './constant'
const emptyDefaultFormData = {
    group: GROUP_TYPE.PLAN,//操作层级
    groupItemList: [],//操作项
    state: '0',//开关
    plannedBudgetType: LIMIT_TYPE.LIMIT,//是否限制计划预算
    plannedBudgetAdjustType: ADJUST_TYPE.ADJUST,//预算类型
    plannedBudget: null,// 预算
    plannedBudgetValueType: ADJUST_VALUE_TYPE.FIXED,// 预算值类型
    plannedBudgetMax: null,// 预算上限


    releaseDateType: LIMIT_TYPE.LIMIT,// 是否限制投放日期
    releaseDate: null,// 投放日期
    releaseOnlyDate: null,// 指定开始日期
    releasePeriodType: LIMIT_TYPE.LIMIT,// 是否限制投放时段
    releasePeriod: new Array(336).fill('0').join(''),// 投放时段
    basePriceAdjustType: ADJUST_TYPE.INCREASE,// 基准价调整类型
    basePriceValueType: ADJUST_VALUE_TYPE.FIXED,// 基准价调整值类型
    basePrice: null,// 基准价
    basePriceMax: null,// 基准价上限

    secondPriceAdjustType: ADJUST_TYPE.INCREASE,// 基准价调整类型
    secondPriceValueType: ADJUST_VALUE_TYPE.FIXED,// 基准价调整值类型
    secondPrice: null,// 基准价
    secondPriceMax: null,// 基准价上限
    
    thirdPriceAdjustType: ADJUST_TYPE.INCREASE,// 三阶出价调整类型
    thirdPriceValueType: ADJUST_VALUE_TYPE.FIXED,// 三阶出价调整值类型
    thirdPrice: null,// 三阶出价
    thirdPriceMax: null,// 三阶出价上限
}
export default {
    name: 'ActionForm',
    props: [ 'platId', 'configAutn', 'defaultFormData','screenType' ],
    inject: [ 'validFormItem' ],
    data() {
        return {
            plannedBudgetUnlimitedBlackList: [PLAT_TYPE.OPPO, PLAT_TYPE.MI ],//计划预算不限黑名单 [oppo, mi] 不支持不限
            releaseDateUnlimitedWhiteList: [ `${PLAT_TYPE.OPPO}-${GROUP_TYPE.ADV_TEAM}` ],// 投放日期不限白名单  组合方式   媒体-操作层级
            formData: {
                ...this.defaultFormData
               
            },
            actionTypeList: [
                ...ACTION_TYPE_LIST
            ]
            
        }
    },
    render(h) {
        
        const _this = this;
        const nodes = [];
         // 操作层级
        const groupNode = _this.creatNode(h, 'ElRadioGroupButton', { 
            list: this.groupList.filter((v)=> {
                return ( +v.value + 1 ) >= _this.screenType
            }),
            key: 'group',
            on: {
                change() {
                    const formData = _.omit({ ...emptyDefaultFormData }, ['group']);
                    formData.group = _this.formData.group;
                     _this.formData = formData;
                    // _this.formData.group = GROUP_TYPE.PLAN;
                    // _this.$message.error('产研同学正在快马加鞭支持中...有想法可以联系相关同学沟通呦～')
                }
            }
        });
        const validGroupItem = (rule, value, callback) => {
            if((_this.screenType || 0) <= (+value + 1)) {
                callback();
            }else {
                callback(new Error('不支持的操作层级'));
            }
        };
        nodes.push(
            h('ElFormItem', {
                props: {
                    label: '操作层级',
                    prop: 'group',
                    rules: {
                        required: true,validator: validGroupItem, trigger: 'blur'
                    }
                },
                scopedSlots: {
                    default: ()=> [ groupNode],
                }
            })
        );

        // 操作项
        const groupItemListNode = _this.creatNode(h, 'ElCheckboxGroup', { 
            list: _this.actMatrixList.map(key=> {
                return {
                    value: key,
                    label: _this.groupValueLabel[key]
                }
            }),
            key: 'groupItemList',
        })
        nodes.push(
            h('ElFormItem', {
                props: {
                    label: '操作项',
                    prop: 'groupItemList',
                    rules:{
                        required: true, message: '请勾选操作项并填写相关的内容', trigger: 'blur'
                    }
                },
                scopedSlots: {
                    default: ()=> [groupItemListNode],
                }
            })
        );
        // 
        nodes.push(
            ..._this.actionFormList(
                h,
                // 保证顺序一致
                _this.actMatrixList.filter(key=> _this.formData.groupItemList.includes(key))
            )
        )
        return h('ElForm', 
            {
                props: {
                    model: _this.formData,
                    ..._this.$attrs
                },
                ref: 'formRef',
                on: {
                    validate: _this.handleValidate,
                },
                nativeOn: {
                    submit: (event)=> {
                        event.preventDefault()
                    }
                }
            }, 
        nodes)
    },
    computed: {
        actMatrixList() {
            if (this.platId && this.formData.group) {
                 return this.configAutn[this.platId][this.formData.group] || []
                //  return ACT_MATRIX[this.platId][this.formData.group] || []
            }else {
                return []
            }
        },
        groupListData() {
            if (this.platId) {
                 return this.configAutn[this.platId].groupListData || []
            }else {
                return []
            }
        },
        groupList() {
            const groupData = this.configAutn[this.platId] || {};
            const groupKeys = Object.keys(groupData);
            console.log(this.groupListData, groupKeys, 'groupKeysgroupKeys');
            return this.groupListData.filter(v=> groupKeys.includes(v.value + ''))
        },
        groupValueLabel() {
            return this.actionTypeList.reduce((pre, item)=> {
                pre[item.value] = item.label;
                return pre
            }, {})
        }
    },
    created() {
        const fn = (val)=> {
            const list = this.groupList.filter((v)=> {
                return ( +v.value + 1 ) >= val
            });
            this.formData.group = _.head(list).value || '';
        }
        this.$bus.$on('screenTypeChange', fn);
        this.$once('hook:beforeDestroy', () => {
            this.$bus.$off('screenTypeChange', fn)
        });
    },
    methods: {
        actionFormList(h, list) {
            const _this = this;
            const validPlannedBudget = (rule, value, callback)=> {
                const budget = this.formData.plannedBudget;
                const djustType = this.formData.plannedBudgetAdjustType;
                const valueType = this.formData.plannedBudgetValueType;
                const priceMax = this.formData.plannedBudgetMax;
                const isAdjust = djustType === ADJUST_TYPE.ADJUST; //是否为调整至
                if( !budget || !validNum(budget) || !isAdjust && (!priceMax || !validNum(priceMax)) ) {
                    callback(new Error('请输入数字'))
                    return
                };
                if(budget.indexOf('.') !== -1 || (!isAdjust && priceMax.indexOf('.') !== -1)) {
                    callback(new Error('请输入整数'))
                    return
                };
                if(+budget <= 0) {
                    callback(new Error('请输入大于0的数字'))
                    return
                };
                if (
                    !this.plannedBudgetUnlimitedBlackList.includes(this.platId)&&
                    this.formData.plannedBudgetType === LIMIT_TYPE.NO_LIMIT
                ) {
                    callback();
                    return;
                };
                if (!budget) {
                    callback(new Error('请输入计划预算'))
                    return
                }
                 const { max, min } = PLAT_PLANNED_BUDGET_TYPE[this.platId]
                if (djustType === ADJUST_TYPE.ADJUST && max && min) {
                    if (!validNum(budget) || budget<min || budget > max) {
                        callback(new Error(`请输入${min}-${max}的数字`))
                        return
                    }
                }
                callback()
            };
            const validReleaseDate = (rule, value, callback)=> {
                const releaseDate = this.formData.releaseDate;
                const releaseOnlyDate = this.formData.releaseOnlyDate;
                const key = `${this.platId}-${this.formData.group}`;
                // 不限
                if (
                    this.releaseDateUnlimitedWhiteList.includes(key)&&
                    value === LIMIT_TYPE.NO_LIMIT
                ) {
                    callback();
                    return;
                };
                if(value === LIMIT_TYPE.LIMIT_DATE && !releaseOnlyDate) {
                    callback(new Error('请选择投放日期'))
                    return
                }
               if(value === LIMIT_TYPE.LIMIT && !(releaseDate && releaseDate.length)) {
                    callback(new Error('请选择投放日期'))
                    return
                };
                const today = new Date(dayjs().format('YYYY-MM-DD')).getTime();
                if ( value === LIMIT_TYPE.LIMIT && today > new Date(releaseDate[0]).getTime()) {
                    callback(new Error('开始日期不可早于当日'))
                }else {
                    callback()
                }
            };
            const validPrice = (rule, value, callback)=> {
                // basePriceAdjustType basePriceValueType basePrice basePriceMax
                console.log(rule, value , 'rule');
                const field = rule.field;
                const adjustType = this.formData[`${field}AdjustType`];
                const valueType = this.formData[`${field}ValueType`];
                const price = this.formData[`${field}`];
                const priceMax = this.formData[`${field}Max`];
                const isAdjust = adjustType === ADJUST_TYPE.ADJUST; //是否为调整至
                if(!(price && (isAdjust || priceMax) )) {
                    callback(new Error('请输入价格'))
                    return
                };
                if(!(validNum(price) && ( isAdjust || validNum(priceMax) ))) {
                    callback(new Error('请输入数字'))
                    return
                };
                if( adjustType === ADJUST_TYPE.INCREASE &&  valueType === ADJUST_VALUE_TYPE.PERCENTAGE) {
                    if( +price >= 100) {
                        callback(new Error('提高百分比不能大于等于100%'))
                        return
                    }
                }
                if( +price <= 0) {
                    callback(new Error('不能小于等于0'))
                    return
                }
                callback()
            }
            const nodeData = {
                [ACTION_TYPE.STATE]:  h('ElFormItem', {
                    props: {
                        label: '开关',
                        prop: 'state',
                        required: true,
                    },
                    scopedSlots: {
                        default: ()=> this.creatNode(h, 'ElSwitch', {
                            key: 'state',
                            props: {
                                activeValue: "1",
                                inactiveValue: "0",
                            }
                        }),
                    }
                }),
                [ACTION_TYPE.PLANNED_BUDGET]: h('ElFormItem', {
                    props: {
                        label: '计划预算',
                        prop: 'plannedBudgetType',
                        // required: this.formData.plannedBudgetType !== LIMIT_TYPE.NO_LIMIT,
                        rules:[
                            {
                                required: true, validator: validPlannedBudget, trigger: 'blur'
                            }
                        ]
                    },
                    scopedSlots: {
                        default: ()=> [
                            // ?null:
                            this.creatNode(h, 'ElRadioGroup', {
                                key: 'plannedBudgetType',
                                list: [ { value: LIMIT_TYPE.NO_LIMIT, label: `不限` }, { value: LIMIT_TYPE.LIMIT, label: '指定预算' }],
                                on: {
                                    change: (value)=> {
                                        _this.$refs.formRef.clearValidate('plannedBudgetType')
                                        if (this.plannedBudgetUnlimitedBlackList.includes(this.platId)) {
                                            this.$message.error('当前媒体不支持计划预算设置不限，请指定预算');
                                            this.formData.plannedBudgetType = LIMIT_TYPE.LIMIT
                                        }else {
                                            if (value !== LIMIT_TYPE.NO_LIMIT) {
                                                return;
                                            }
                                            const onSubmit = (type)=> {
                                                if (!type) {
                                                    this.formData.plannedBudgetType = LIMIT_TYPE.LIMIT
                                                };
                                                vm.close()
                                            }
                                            const { vm } = messageTipModal({
                                                 props: {
                                                    message: '不建议预算设置不限，可能会导致消耗无法把控，甚至出现事故的可能确认要继续设置不限吗?',
                                                    onText: '继续设置',
                                                    closeText: '取消'
                                                },
                                                cbs: { onSubmit }
                                            })
                                        }
                                        
                                    }
                                }
                            }),
                            _this.formData.plannedBudgetType === LIMIT_TYPE.LIMIT || _this.plannedBudgetUnlimitedBlackList.includes(_this.platId)?
                            h('div',null, [
                                    this.creatNode(h, 'ElSelect', {
                                        key: 'plannedBudgetAdjustType',
                                        list: [ ...ADJUST_TYPE_LIST ].filter(v=>  !(v.value !== ADJUST_TYPE.ADJUST && this.platId !== PLAT_TYPE.MI)),
                                        class: 'mr10',
                                        props: {
                                            placeholder: '请选择调整类型',
                                        },
                                        on: {
                                            change: (value)=> {
                                                if( ADJUST_TYPE.ADJUST === value) {
                                                    this.formData.plannedBudgetValueType = ADJUST_VALUE_TYPE.FIXED;
                                                    this.formData.plannedBudget = '';
                                                }
                                            }
                                        }
                                    }),
                                    [
                                        this.formData.plannedBudgetAdjustType === ADJUST_TYPE.ADJUST? null :

                                        this.creatNode(h, 'ElSelect', {
                                            key: 'plannedBudgetValueType',
                                            list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                            class: 'mr10',
                                            props: {
                                                placeholder: '请选择调整值类型'
                                            }
                                        })
                                    ],
                                    this.creatNode(h, 'ElInput', {
                                        key: 'plannedBudget',
                                        class: 'mr10',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '200px'
                                        },
                                        on: {
                                            blur: (event)=> {
                                                 event.stopPropagation();
                                                this.priceWarnTip({
                                                    label: '计划预算',
                                                    type: this.formData.plannedBudgetAdjustType,
                                                    valueType: this.formData.plannedBudgetValueType,
                                                    price: this.formData.plannedBudget,
                                                })
                                            }
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gray mr10' }, [
                                        this.formData.plannedBudgetValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                                    ]),
                                    [
                                        this.formData.plannedBudgetAdjustType === ADJUST_TYPE.ADJUST? null :
                                        [
                                            h('span', { class: 'font12px text-color-gra mr10' }, ['最多调整至']),
                                            this.creatNode(h, 'ElInput', {
                                                key: 'plannedBudgetMax',
                                                attrs: {
                                                    placeholder: '请输入数值'
                                                },
                                                style: {
                                                    width: '200px'
                                                }
                                            }),
                                            h('span', { class: 'font12px text-color-gra mr10' }, ['￥'])
                                        ]
                                    ],
                                ])
                            :null,
                            
                        ],
                    }
                }),
                [ACTION_TYPE.RELEASE_DATE]: h('ElFormItem', {
                    props: {
                        label: '投放日期',
                        prop: 'releaseDateType',
                        rules:{
                            required: true, validator: validReleaseDate, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            this.creatNode(h, 'ElRadioGroup', {
                                key: 'releaseDateType',

                                list: [ { value: LIMIT_TYPE.NO_LIMIT, label: '不限' },  { value: LIMIT_TYPE.LIMIT_DATE, label: '指定开始日期' }, { value: LIMIT_TYPE.LIMIT, label: '指定日期' }],
                                on: {
                                    change: (value)=> {
                                        _this.$refs.formRef.clearValidate('releaseDateType');
                                        if ([LIMIT_TYPE.LIMIT, LIMIT_TYPE.LIMIT_DATE].includes(value)) {
                                            return;
                                        }
                                        const key = `${this.platId}-${this.formData.group}`
                                        if (!this.releaseDateUnlimitedWhiteList.includes(key)) {
                                            this.$message.error('当前媒体不支持投放日期设置不限，请指定日期');
                                            this.formData.releaseDateType = LIMIT_TYPE.LIMIT
                                        }
                                    }
                                }
                            }),
                            _this.formData.releaseDateType === LIMIT_TYPE.LIMIT_DATE ?
                            h('div',{ class: 'font12px text-color-gray' }, [
                                this.creatNode(h, 'ElDatePicker', {
                                    key: 'releaseOnlyDate',
                                    props: {
                                        type: 'date',
                                        placeholder:"请选择开始日期",
                                        valueFormat: "yyyy-MM-dd",
                                        pickerOptions: {
                                            disabledDate(time) {
                                                return time.getTime()< (Date.now() - 24 * 60 * 60 * 1000)
                                            }
                                        }
                                    }, 
                                }),
                                ' - 结束不限'
                            ]):
                            _this.formData.releaseDateType === LIMIT_TYPE.LIMIT?
                            h('div',null, [
                                this.creatNode(h, 'ElDatePicker', {
                                    key: 'releaseDate',
                                    props: {
                                        type: 'daterange',
                                        rangeSeparator:"至",
                                        startPlaceholder:"开始日期",
                                        endPlaceholder: "结束日期",
                                        valueFormat: "yyyy-MM-dd",
                                        pickerOptions: {
                                            disabledDate(time) {
                                                return time.getTime()< (Date.now() - 24 * 60 * 60 * 1000)
                                            }
                                        }
                                    }, 
                                })
                            ])
                            : null,
                        ],
                    }
                }),
                [ACTION_TYPE.RELEASE_PERIOD]: h('ElFormItem', {
                    props: {
                        label: '投放时段',
                        prop:'releasePeriodType',
                        rules:{
                            required: true, message: '请选择投放时段', trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            this.creatNode(h, 'ElRadioGroup', {
                                key: 'releasePeriodType',

                                list: [ { value: LIMIT_TYPE.NO_LIMIT, label: '不限' }, { value: LIMIT_TYPE.LIMIT, label: '指定时段' }],
                                on: {
                                    change: (value)=> {
                                        // _this.$refs.formRef.clearValidate('releaseDateType');
                                        // if ([LIMIT_TYPE.LIMIT, LIMIT_TYPE.LIMIT_DATE].includes(value)) {
                                        //     return;
                                        // }
                                        // const key = `${this.platId}-${this.formData.group}`
                                        // if (!this.releaseDateUnlimitedWhiteList.includes(key)) {
                                        //     this.$message.error('当前媒体不支持投放日期设置不限，请指定日期');
                                        //     this.formData.releaseDateType = LIMIT_TYPE.LIMIT
                                        // }
                                    }
                                }
                            }),
                            _this.formData.releasePeriodType === LIMIT_TYPE.LIMIT?
                            this.creatNode(h, 'DropTimes', { 
                                key:'releasePeriod',
                                props: {
                                    weekDate: [ '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日' ]
                                }
                            }):
                            null
                        ]
                    }
                }),
                [ACTION_TYPE.BASE_PRICE]: h('ElFormItem', {
                    props: {
                        label: '基础价格',
                        prop:'basePrice',
                        rules:{
                            required: true, validator: validPrice, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            // _this.formData.basePriceAdjustType,
                            this.creatNode(h, 'ElSelect', {
                                key: 'basePriceAdjustType',
                                list: [ ...ADJUST_TYPE_LIST ],
                                class: 'mr10',
                                props: {
                                    placeholder: '请选择调整类型',
                                },
                                on: {
                                    blur: (value)=> {
                                      
                                    }
                                }
                            }),
                            [
                                 this.formData.basePriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                 this.creatNode(h, 'ElSelect', {
                                    key: 'basePriceValueType',
                                    list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                    class: 'mr10',
                                    props: {
                                        placeholder: '请选择调整值类型'
                                    },
                                    on: {
                                        change: (value)=> {
                                            if( ADJUST_TYPE.ADJUST === value) {
                                                this.formData.basePriceValueType = ADJUST_VALUE_TYPE.FIXED;
                                                this.formData.basePriceMax = '';
                                                this.formData.basePrice = '';
                                            }
                                        }
                                    }   
                                }),
                            ],
                            this.creatNode(h, 'ElInput', {
                                key: 'basePrice',
                                class: 'mr10',
                                attrs: {
                                    placeholder: '请输入数值'
                                },
                                style: {
                                    width: '200px'
                                },
                                on: {
                                    blur: (event)=> {
                                         event.stopPropagation();
                                        this.priceWarnTip({
                                            label: '基础价格',
                                            type: this.formData.basePriceAdjustType,
                                            valueType: this.formData.basePriceValueType,
                                            price: this.formData.basePrice,
                                        })
                                    }
                                }
                            }),
                            h('span', { class: 'font12px text-color-gra mr10' }, [
                                this.formData.basePriceValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                            ]),
                            [
                                this.formData.basePriceAdjustType === ADJUST_TYPE.ADJUST? null :
                               [
                                 h('span', { class: 'font12px text-color-gra mr10' }, ['最多调整至']),
                                    this.creatNode(h, 'ElInput', {
                                        key: 'basePriceMax',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '200px'
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gra mr10' }, ['￥']),
                               ]
                            ]
                        ],
                    }
                }),
                [ACTION_TYPE.SECOND_PRICE]: h('ElFormItem', {
                    props: {
                        label: '二阶价格',
                        prop:'secondPrice',
                        rules:{
                            required: true, validator: validPrice, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            this.creatNode(h, 'ElSelect', {
                                key: 'secondPriceAdjustType',
                                list: [ ...ADJUST_TYPE_LIST ],
                                class: 'mr10',
                                props: {
                                    placeholder: '请选择调整类型',
                                },
                                on: {
                                    change: (value)=> {
                                        if( ADJUST_TYPE.ADJUST === value) {
                                            this.formData.secondPriceValueType = ADJUST_VALUE_TYPE.FIXED;
                                            this.formData.secondMaxPrice = '';
                                            this.formData.secondPrice = '';
                                        }
                                    }
                                }
                            }),
                            [
                                this.formData.secondPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                this.creatNode(h, 'ElSelect', {
                                    key: 'secondPriceValueType',
                                    list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                    class: 'mr10',
                                    props: {
                                        placeholder: '请选择调整值类型'
                                    }
                                })
                            ],
                            this.creatNode(h, 'ElInput', {
                                key: 'secondPrice',
                                class: 'mr10',
                                attrs: {
                                    placeholder: '请输入数值'
                                },
                                style: {
                                    width: '200px'
                                },
                                on: {
                                    blur: (event)=> {
                                         event.stopPropagation();
                                        this.priceWarnTip({
                                            label: '二阶价格',
                                            type: this.formData.secondPriceAdjustType,
                                            valueType: this.formData.secondPriceValueType,
                                            price: this.formData.secondPrice,
                                        })
                                    }
                                }
                            }),
                            h('span', { class: 'font12px text-color-gra mr10' }, [
                                this.formData.secondPriceValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                            ]),
                            [
                                this.formData.secondPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                [
                                    h('span', { class: 'font12px text-color-gra mr10' }, ['最多调整至']),
                                    this.creatNode(h, 'ElInput', {
                                        key: 'secondPriceMax',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '200px'
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gra mr10' }, ['￥'])
                                ]
                            ],
                        ],
                    }
                }),
                [ACTION_TYPE.THIRD_PRICE]: h('ElFormItem', {
                    props: {
                        label: '三阶价格',
                        prop:'thirdPrice',
                        rules:{
                            required: true, validator: validPrice, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            this.creatNode(h, 'ElSelect', {
                                key: 'thirdPriceAdjustType',
                                list: [ ...ADJUST_TYPE_LIST ],
                                class: 'mr10',
                                props: {
                                    placeholder: '请选择调整类型',
                                },
                                on: {
                                    change: (value)=> {
                                        if( ADJUST_TYPE.ADJUST === value) {
                                            this.formData.thirdPriceValueType = ADJUST_VALUE_TYPE.FIXED;
                                            this.formData.thirdMaxPrice = '';
                                            this.formData.thirdPrice = '';
                                        }
                                    }
                                }
                            }),
                            [
                                this.formData.thirdPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                this.creatNode(h, 'ElSelect', {
                                    key: 'thirdPriceValueType',
                                    list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                    class: 'mr10',
                                    props: {
                                        placeholder: '请选择调整值类型'
                                    }
                                })
                            ],
                            this.creatNode(h, 'ElInput', {
                                key: 'thirdPrice',
                                class: 'mr10',
                                attrs: {
                                    placeholder: '请输入数值'
                                },
                                style: {
                                    width: '200px'
                                },
                                on: {
                                    blur: (event)=> {
                                        event.stopPropagation();
                                        this.priceWarnTip({
                                            label: '三阶价格',
                                            type: this.formData.thirdPriceAdjustType,
                                            valueType: this.formData.thirdPriceValueType,
                                            price: this.formData.thirdPrice,
                                        })
                                    }
                                }

                            }),
                            h('span', { class: 'font12px text-color-gra mr10' }, [
                                this.formData.thirdPriceValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                            ]),
                            [
                                this.formData.thirdPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                [
                                    h('span', { class: 'font12px text-color-gra mr10' }, ['最多调整至']),
                                    this.creatNode(h, 'ElInput', {
                                        key: 'thirdPriceMax',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '200px'
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gra mr10' }, ['￥'])
                                ]
                            ],
                        ],
                    }
                }),
            };
            return list.map(key=> h('div', { class: 'mb20 p10', style: { 'backgroundColor': '#f5f7fa' } }, [ nodeData[key] ]))
        },
        // 自定义v-model
        formCustomModel(key, isNum = false) {
            return {
                props: {
                    value: this.formData[key],
                },
                on: {
                    input: (val)=> {
                        this.formData[key] = val;
                    }
                }
            }
        },
        creatNode(h, name, params) {
            const { key } = params
            const defaultAttr = this.formCustomModel(key)
            switch (name) {
                case 'ElRadioGroupButton': {
                    const { list, ...attrs } = params;
                    const nodes = list.map(v=> h('ElRadioButton', { props: { label: v.value } }, [ v.label ]))
                    return h('ElRadioGroup', _.merge(defaultAttr, attrs , { scopedSlots: { default: ()=> nodes} }) );
                }
                case 'ElCheckboxGroup': {
                    const { list, ...attrs } = params;
                    const nodes = list.map(v=> h('ElCheckbox', { props: { label: v.value } }, [ v.label ]))
                    return h('ElCheckboxGroup', _.merge( defaultAttr , attrs , { scopedSlots: { default: ()=> nodes} }) );
                }
                case 'ElRadioGroup': {
                    const { list, ...attrs } = params;
                    const nodes = list.map(v=> h('ElRadio', { props: { label: v.value } }, [ v.label ]))
                    return h('ElRadioGroup', _.merge( defaultAttr , attrs , { scopedSlots: { default: ()=> nodes} }) );
                }
                case 'ElSwitch': {
                    return h('ElSwitch', _.merge( defaultAttr , params ) );
                }
                case 'ElDatePicker': {
                    return h('ElDatePicker', _.merge( defaultAttr , params ) );
                }
                case 'ElInput': {
                    return h('ElInput', _.merge( this.formCustomModel(key, true) , params ) );
                }
                case 'DropTimes': {
                    return h(DropTimes, _.merge( defaultAttr, params ) );
                }
                case 'ElSelect': {
                    const { list,...attrs } = params;
                    const nodes = list.map(v=> h('ElOption', { props: { label: v.label, value: v.value } }, [ v.label ]))
                    return h('ElSelect', _.merge( defaultAttr, attrs, { scopedSlots: { default: ()=> nodes} }) );
                }
                default:
                    break;
            }
        },
        async validateFn() {
            const valid = await this.$refs.formRef.validate();
            const limitTypeValues =  Object.values(LIMIT_TYPE);
            const formData = this.formData;
            // 格式化成后端需要的数据
           console.log( formData.groupItemList, this.actMatrixList,' formData.groupItemList');
            const operation_items = formData.groupItemList.filter(v=> {
                return this.actMatrixList.includes(v);
            }).reduce((pre, key)=> {
                const typeKey = `${key}Type`;
                const targetKey = ACTION_TYPE_DATA[key];
                if (!limitTypeValues.includes(formData[typeKey])) {
                    if( [
                            ACTION_TYPE.BASE_PRICE, ACTION_TYPE.SECOND_PRICE ,ACTION_TYPE.THIRD_PRICE
                        ].includes(key) ) {
                            // {"operator":"increase","type":"percentage","value":0.5,"boundary":0.04}
                            pre[targetKey] = {
                                operator: formData[`${key}AdjustType`],
                                type: formData[`${key}ValueType`],
                                value: formData[key],
                                boundary: formData[`${key}Max`],
                            };
                        }else {
                            pre[targetKey] = formData[key]
                        }
                }else {
                    if (formData[typeKey] === LIMIT_TYPE.NO_LIMIT) {
                        pre[targetKey] = ''
                    }else {
                        // 日期单独处理
                        if (ACTION_TYPE.RELEASE_DATE === key) {
                            if(formData[typeKey] === LIMIT_TYPE.LIMIT_DATE) {
                                pre[targetKey] = formData['releaseOnlyDate'];
                            }else {
                                pre[targetKey] = (formData[key] || []).join('/');
                            }
                        }else if( [
                            ACTION_TYPE.PLANNED_BUDGET
                        ].includes(key) ) {
                            // {"operator":"increase","type":"percentage","value":0.5,"boundary":0.04}
                            pre[targetKey] = {
                                operator: formData[`${key}AdjustType`],
                                type: formData[`${key}ValueType`],
                                value: formData[key],
                                boundary: formData[`${key}Max`],
                            };
                        } else {
                            pre[targetKey] = formData[key];
                        }
                    }
                }
                return pre;
            }, {});
           console.log(operation_items, 'operation_items');
            if (valid) {
                return { ...this.formData, operation_items: JSON.stringify(operation_items) }
            }
        },
        handleValidate(key, valid, info) {
            const data = {
                group: '操作-操作层级',
                groupItemList: '操作-操作项',
                state: '操作-开关',
                plannedBudgetType: '操作-计划预算',
                releaseDateType: '操作-投放日期',
                basePrice: '操作-基础出价',
                secondPrice: '操作-二阶出价',
                thirdPrice: '操作-三阶出价',
                releasePeriodType: '操作-投放时段',
            };
            if (!valid) {
                this.validFormItem(`${data[key]}：${info}`);
            }
        },
        // 出价提示
        async priceWarnTip({ type, valueType, price, label }) {
            await new Promise((resolve)=> {
               setTimeout(resolve, 300)
            });
            if(
                type === ADJUST_TYPE.INCREASE && valueType === ADJUST_VALUE_TYPE.PERCENTAGE && price
            ) {
                if(price >= 100) {
                    
                     const onSubmit = (type)=> {
                        console.log(label);
                        vm.close()
                    }
                    const { vm } = messageTipModal({
                        props: {
                            message: `您设置的【${label}】提高【${price}%】,操作存在风险，暂不支持批量操作！`,
                            closeText: '取消'
                        },
                        cbs: { onSubmit }
                    });
                }else if( price >=50 ){
                    
                     const onSubmit = (type)=> {
                        console.log(label);
                        vm.close()
                    }
                    const { vm } = messageTipModal({
                            props: {
                            message: `您设置的【${label}】提高【${price}%】,操作可能存在风险，请谨慎操作？`,
                            closeText: '已知晓'
                        },
                        cbs: { onSubmit }
                    })
                }
                
            }
        }
    },
    watch: {
        platId() {
            this.formData = { ...emptyDefaultFormData }
        },
    }
}
</script>

<style lang="scss" scoped>
.company-text {
    font-size: 12px;
    padding-left: 10px;
    color: #606266;
}
</style>